<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${stockMovement.code}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="stockMovement" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "stock-movement-view-logs",

  components: { LogListTable },

  props: ["stockMovement"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
